export const SET_REGISTER = '[REGISTER] SET REGISTER';
export const REMOVE_REGISTER = '[REGISTER] REMOVE REGISTER';

export function setRegister(value)
{
    return {
        type: SET_REGISTER,
        payload: value
    };
}

export function removeRegister()
{
    return {
        type: REMOVE_REGISTER
    }
}

